import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.global.AcceptInvitationContent', {
    invitationAcceptedToast: 'The invitation was accepted.',
    successHeaderTitleText: '{name},{br}you accepted the invitation!',
    stepInvitationsTitle: 'Your Invitations',
    stepInvitationsTitleMobile: 'You were invited to the following organisations:',
    nextButton: 'Next',
});
